import React from 'react';
import styles from './header.scss';
import $ from 'jquery';

function Header(props) {
  const {
    curPanel,
    setCurPanel,
    headerStyle,
    setAsideStyle,
    setHeaderStyle,
  } = props;

  const scrollOhthersBesides = name => {
    if (name !== 'aboutUs') {
      const ele = document.getElementById('about-us');
      ele.scrollLeft = 0;
    }

    if (name !== 'productsAndServices') {
      const ele = document.getElementById('productsAndServices');
      ele.scrollLeft = 0;
    }

    if (name !== 'ourTeam') {
      const ele = document.getElementById('ourTeam');
      ele.scrollLeft = 0;
    }

    if (name !== 'partner') {
      const ele = document.getElementById('partner');
      ele.scrollLeft = 0;
    }

    if (name !== 'ourTrend') {
      const ele = document.getElementById('ourTrend');
      ele.scrollLeft = 0;
    }
  }

  return (
    <header className={styles.header}>
      <div
        className={`${styles.item} ${curPanel === 'aboutUs' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'aboutUs') {
            const ele = document.getElementById('about-us');
            $(ele).animate({ scrollLeft: '0' }, 100, 'linear');
            return;
          }

          scrollOhthersBesides('aboutUs');

          setCurPanel('aboutUs');
          setAsideStyle({ backgroundColor: '#DCDDEB', theme: 'black' });
          setHeaderStyle({});

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 关于我们';
        }}
      >
        关于我们
      </div>

      <div
        className={`${styles.item} ${curPanel === 'productsAndServices' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'productsAndServices') {
            const ele = document.getElementById('productsAndServices');
            $(ele).animate({ scrollLeft: '0' }, 100, 'linear');
            return;
          };

          scrollOhthersBesides('productsAndServices');

          setCurPanel('productsAndServices');
          setAsideStyle({ backgroundColor: '#f5f5f5', theme: 'black' });
          setHeaderStyle({});

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 产品与服务';
        }}
      >
        产品与服务
      </div>

      <div
        className={`${styles.item} ${curPanel === 'ourTeam' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'ourTeam') {
            const ele = document.getElementById('ourTeam');
            $(ele).animate({ scrollLeft: '0' }, 100, 'linear');
            return;
          };

          scrollOhthersBesides('ourTeam');

          setCurPanel('ourTeam');
          setAsideStyle({ backgroundColor: '#dce2eb', theme: 'black' });
          setHeaderStyle({});

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 我们的团队';
        }}
      >
        我们的团队
      </div>

      <div
        className={`${styles.item} ${curPanel === 'partner' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'partner') {
            const ele = document.getElementById('partner');
            $(ele).animate({ scrollLeft: '0' }, 100, 'linear');
            return;
          };

          scrollOhthersBesides('partner');

          setCurPanel('partner');
          setAsideStyle({ backgroundColor: '#e2e9ea', theme: 'black' });
          setHeaderStyle({});

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 合作伙伴';
        }}
      >
        合作伙伴
      </div>

      <div
        className={`${styles.item} ${curPanel === 'ourTrend' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'ourTrend') {
            const ele = document.getElementById('ourTrend');
            $(ele).animate({ scrollLeft: '0' }, 100, 'linear');
            return;
          };

          scrollOhthersBesides('ourTrend');

          setCurPanel('ourTrend');
          setAsideStyle({ backgroundColor: '#dce2eb', theme: 'black' });
          setHeaderStyle({});

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 我们的动向';
        }}
      >
        我们的动向
      </div>

      <div
        className={`${styles.item} ${curPanel === 'contactUs' ? styles.active : ''} ${headerStyle.theme === 'white' ? styles.item_white : styles.item_black}`}
        onClick={() => {
          if (curPanel === 'contactUs') {
            return;
          };

          setCurPanel('contactUs');
          setAsideStyle({ backgroundColor: '#3a626d', theme: 'white' });
          setHeaderStyle({ theme: 'white' });

          document.getElementById('wow-title').innerHTML = 'WOW-TREND 热点趋势 | 联系我们';
        }}
      >
        联系我们
      </div>
    </header>
  );
}

export default Header;